<template>
	<header>
		<!-- Top-Header -->
		<Topbar />
		<!-- Top-Header /- -->
		<!-- Mid-Header -->
		<MidHeader />
		<!-- Mid-Header /- -->
		<!-- Responsive-Buttons -->
	
		<!-- Responsive-Buttons /- -->
		<!-- Mini Cart -->
		<Cart />
		<!-- Mini Cart /- -->
		<!-- Bottom-Header -->
		<ContentLoader viewBox="0 0 500 15" v-if="status.fetchCategories.loading">
			<rect x="0" y="0" rx="0" ry="0" width="500" height="15" />
		</ContentLoader>
		<BottomHeader v-else />
		<!-- <BottomHeader /> -->
		<!-- Bottom-Header /- -->
	</header>
</template>

<script>
	import Topbar from "./Topbar.vue";
	import MidHeader from "./MidHeader.vue";
	import BottomHeader from "./BottomHeader.vue";
	import Cart from "./Cart.vue";
	import {mapActions, mapGetters} from "vuex";
	import {ContentLoader} from "vue-content-loader";
	export default {
		computed: {...mapGetters("cat", ["getCategories", "status"])},
		components: {Topbar, MidHeader, BottomHeader, Cart, ContentLoader},
	};
</script>

<style></style>
